"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: babylon/btccheckpoint/v1/btccheckpoint.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.BTCCheckpointInfo = exports.CheckpointAddresses = exports.EpochData = exports.SubmissionData = exports.TransactionInfo = exports.SubmissionKey = exports.TransactionKey = exports.BTCSpvProof = exports.BtcStatus = exports.protobufPackage = void 0;
exports.btcStatusFromJSON = btcStatusFromJSON;
exports.btcStatusToJSON = btcStatusToJSON;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
exports.protobufPackage = "babylon.btccheckpoint.v1";
/** BtcStatus is an enum describing the current btc status of the checkpoint */
var BtcStatus;
(function (BtcStatus) {
    /**
     * EPOCH_STATUS_SUBMITTED - SUBMITTED Epoch has Submitted btc status if there ever was at least one
     * known submission on btc main chain
     */
    BtcStatus[BtcStatus["EPOCH_STATUS_SUBMITTED"] = 0] = "EPOCH_STATUS_SUBMITTED";
    /**
     * EPOCH_STATUS_CONFIRMED - CONFIRMED Epoch has Confirmed btc status if there ever was at least one
     * known submission on btc main chain which was k-deep
     */
    BtcStatus[BtcStatus["EPOCH_STATUS_CONFIRMED"] = 1] = "EPOCH_STATUS_CONFIRMED";
    /**
     * EPOCH_STATUS_FINALIZED - CONFIRMED Epoch has Finalized btc status if there is was at exactly one
     * knon submission on btc main chain which is w-deep
     */
    BtcStatus[BtcStatus["EPOCH_STATUS_FINALIZED"] = 2] = "EPOCH_STATUS_FINALIZED";
    BtcStatus[BtcStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BtcStatus || (exports.BtcStatus = BtcStatus = {}));
function btcStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "EPOCH_STATUS_SUBMITTED":
            return BtcStatus.EPOCH_STATUS_SUBMITTED;
        case 1:
        case "EPOCH_STATUS_CONFIRMED":
            return BtcStatus.EPOCH_STATUS_CONFIRMED;
        case 2:
        case "EPOCH_STATUS_FINALIZED":
            return BtcStatus.EPOCH_STATUS_FINALIZED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return BtcStatus.UNRECOGNIZED;
    }
}
function btcStatusToJSON(object) {
    switch (object) {
        case BtcStatus.EPOCH_STATUS_SUBMITTED:
            return "EPOCH_STATUS_SUBMITTED";
        case BtcStatus.EPOCH_STATUS_CONFIRMED:
            return "EPOCH_STATUS_CONFIRMED";
        case BtcStatus.EPOCH_STATUS_FINALIZED:
            return "EPOCH_STATUS_FINALIZED";
        case BtcStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseBTCSpvProof() {
    return {
        btcTransaction: new Uint8Array(0),
        btcTransactionIndex: 0,
        merkleNodes: new Uint8Array(0),
        confirmingBtcHeader: new Uint8Array(0),
    };
}
exports.BTCSpvProof = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.btcTransaction.length !== 0) {
            writer.uint32(10).bytes(message.btcTransaction);
        }
        if (message.btcTransactionIndex !== 0) {
            writer.uint32(16).uint32(message.btcTransactionIndex);
        }
        if (message.merkleNodes.length !== 0) {
            writer.uint32(26).bytes(message.merkleNodes);
        }
        if (message.confirmingBtcHeader.length !== 0) {
            writer.uint32(34).bytes(message.confirmingBtcHeader);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBTCSpvProof();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.btcTransaction = reader.bytes();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.btcTransactionIndex = reader.uint32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.merkleNodes = reader.bytes();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.confirmingBtcHeader = reader.bytes();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            btcTransaction: isSet(object.btcTransaction) ? bytesFromBase64(object.btcTransaction) : new Uint8Array(0),
            btcTransactionIndex: isSet(object.btcTransactionIndex) ? globalThis.Number(object.btcTransactionIndex) : 0,
            merkleNodes: isSet(object.merkleNodes) ? bytesFromBase64(object.merkleNodes) : new Uint8Array(0),
            confirmingBtcHeader: isSet(object.confirmingBtcHeader)
                ? bytesFromBase64(object.confirmingBtcHeader)
                : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.btcTransaction.length !== 0) {
            obj.btcTransaction = base64FromBytes(message.btcTransaction);
        }
        if (message.btcTransactionIndex !== 0) {
            obj.btcTransactionIndex = Math.round(message.btcTransactionIndex);
        }
        if (message.merkleNodes.length !== 0) {
            obj.merkleNodes = base64FromBytes(message.merkleNodes);
        }
        if (message.confirmingBtcHeader.length !== 0) {
            obj.confirmingBtcHeader = base64FromBytes(message.confirmingBtcHeader);
        }
        return obj;
    },
    create(base) {
        return exports.BTCSpvProof.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBTCSpvProof();
        message.btcTransaction = object.btcTransaction ?? new Uint8Array(0);
        message.btcTransactionIndex = object.btcTransactionIndex ?? 0;
        message.merkleNodes = object.merkleNodes ?? new Uint8Array(0);
        message.confirmingBtcHeader = object.confirmingBtcHeader ?? new Uint8Array(0);
        return message;
    },
};
function createBaseTransactionKey() {
    return { index: 0, hash: new Uint8Array(0) };
}
exports.TransactionKey = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.index !== 0) {
            writer.uint32(8).uint32(message.index);
        }
        if (message.hash.length !== 0) {
            writer.uint32(18).bytes(message.hash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTransactionKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.index = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.hash = reader.bytes();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            index: isSet(object.index) ? globalThis.Number(object.index) : 0,
            hash: isSet(object.hash) ? bytesFromBase64(object.hash) : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.index !== 0) {
            obj.index = Math.round(message.index);
        }
        if (message.hash.length !== 0) {
            obj.hash = base64FromBytes(message.hash);
        }
        return obj;
    },
    create(base) {
        return exports.TransactionKey.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransactionKey();
        message.index = object.index ?? 0;
        message.hash = object.hash ?? new Uint8Array(0);
        return message;
    },
};
function createBaseSubmissionKey() {
    return { key: [] };
}
exports.SubmissionKey = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.key) {
            exports.TransactionKey.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubmissionKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key.push(exports.TransactionKey.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { key: globalThis.Array.isArray(object?.key) ? object.key.map((e) => exports.TransactionKey.fromJSON(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.key?.length) {
            obj.key = message.key.map((e) => exports.TransactionKey.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.SubmissionKey.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubmissionKey();
        message.key = object.key?.map((e) => exports.TransactionKey.fromPartial(e)) || [];
        return message;
    },
};
function createBaseTransactionInfo() {
    return { key: undefined, transaction: new Uint8Array(0), proof: new Uint8Array(0) };
}
exports.TransactionInfo = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.key !== undefined) {
            exports.TransactionKey.encode(message.key, writer.uint32(10).fork()).join();
        }
        if (message.transaction.length !== 0) {
            writer.uint32(18).bytes(message.transaction);
        }
        if (message.proof.length !== 0) {
            writer.uint32(26).bytes(message.proof);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTransactionInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = exports.TransactionKey.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.transaction = reader.bytes();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.proof = reader.bytes();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? exports.TransactionKey.fromJSON(object.key) : undefined,
            transaction: isSet(object.transaction) ? bytesFromBase64(object.transaction) : new Uint8Array(0),
            proof: isSet(object.proof) ? bytesFromBase64(object.proof) : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== undefined) {
            obj.key = exports.TransactionKey.toJSON(message.key);
        }
        if (message.transaction.length !== 0) {
            obj.transaction = base64FromBytes(message.transaction);
        }
        if (message.proof.length !== 0) {
            obj.proof = base64FromBytes(message.proof);
        }
        return obj;
    },
    create(base) {
        return exports.TransactionInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransactionInfo();
        message.key = (object.key !== undefined && object.key !== null)
            ? exports.TransactionKey.fromPartial(object.key)
            : undefined;
        message.transaction = object.transaction ?? new Uint8Array(0);
        message.proof = object.proof ?? new Uint8Array(0);
        return message;
    },
};
function createBaseSubmissionData() {
    return { vigilanteAddresses: undefined, txsInfo: [], epoch: 0 };
}
exports.SubmissionData = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.vigilanteAddresses !== undefined) {
            exports.CheckpointAddresses.encode(message.vigilanteAddresses, writer.uint32(10).fork()).join();
        }
        for (const v of message.txsInfo) {
            exports.TransactionInfo.encode(v, writer.uint32(18).fork()).join();
        }
        if (message.epoch !== 0) {
            writer.uint32(24).uint64(message.epoch);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubmissionData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.vigilanteAddresses = exports.CheckpointAddresses.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.txsInfo.push(exports.TransactionInfo.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.epoch = longToNumber(reader.uint64());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            vigilanteAddresses: isSet(object.vigilanteAddresses)
                ? exports.CheckpointAddresses.fromJSON(object.vigilanteAddresses)
                : undefined,
            txsInfo: globalThis.Array.isArray(object?.txsInfo)
                ? object.txsInfo.map((e) => exports.TransactionInfo.fromJSON(e))
                : [],
            epoch: isSet(object.epoch) ? globalThis.Number(object.epoch) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.vigilanteAddresses !== undefined) {
            obj.vigilanteAddresses = exports.CheckpointAddresses.toJSON(message.vigilanteAddresses);
        }
        if (message.txsInfo?.length) {
            obj.txsInfo = message.txsInfo.map((e) => exports.TransactionInfo.toJSON(e));
        }
        if (message.epoch !== 0) {
            obj.epoch = Math.round(message.epoch);
        }
        return obj;
    },
    create(base) {
        return exports.SubmissionData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubmissionData();
        message.vigilanteAddresses = (object.vigilanteAddresses !== undefined && object.vigilanteAddresses !== null)
            ? exports.CheckpointAddresses.fromPartial(object.vigilanteAddresses)
            : undefined;
        message.txsInfo = object.txsInfo?.map((e) => exports.TransactionInfo.fromPartial(e)) || [];
        message.epoch = object.epoch ?? 0;
        return message;
    },
};
function createBaseEpochData() {
    return { keys: [], status: 0 };
}
exports.EpochData = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.keys) {
            exports.SubmissionKey.encode(v, writer.uint32(10).fork()).join();
        }
        if (message.status !== 0) {
            writer.uint32(16).int32(message.status);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEpochData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.keys.push(exports.SubmissionKey.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.status = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            keys: globalThis.Array.isArray(object?.keys) ? object.keys.map((e) => exports.SubmissionKey.fromJSON(e)) : [],
            status: isSet(object.status) ? btcStatusFromJSON(object.status) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.keys?.length) {
            obj.keys = message.keys.map((e) => exports.SubmissionKey.toJSON(e));
        }
        if (message.status !== 0) {
            obj.status = btcStatusToJSON(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.EpochData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEpochData();
        message.keys = object.keys?.map((e) => exports.SubmissionKey.fromPartial(e)) || [];
        message.status = object.status ?? 0;
        return message;
    },
};
function createBaseCheckpointAddresses() {
    return { submitter: new Uint8Array(0), reporter: new Uint8Array(0) };
}
exports.CheckpointAddresses = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.submitter.length !== 0) {
            writer.uint32(10).bytes(message.submitter);
        }
        if (message.reporter.length !== 0) {
            writer.uint32(18).bytes(message.reporter);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCheckpointAddresses();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.submitter = reader.bytes();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.reporter = reader.bytes();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            submitter: isSet(object.submitter) ? bytesFromBase64(object.submitter) : new Uint8Array(0),
            reporter: isSet(object.reporter) ? bytesFromBase64(object.reporter) : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.submitter.length !== 0) {
            obj.submitter = base64FromBytes(message.submitter);
        }
        if (message.reporter.length !== 0) {
            obj.reporter = base64FromBytes(message.reporter);
        }
        return obj;
    },
    create(base) {
        return exports.CheckpointAddresses.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCheckpointAddresses();
        message.submitter = object.submitter ?? new Uint8Array(0);
        message.reporter = object.reporter ?? new Uint8Array(0);
        return message;
    },
};
function createBaseBTCCheckpointInfo() {
    return {
        epochNumber: 0,
        bestSubmissionBtcBlockHeight: 0,
        bestSubmissionBtcBlockHash: new Uint8Array(0),
        bestSubmissionTransactions: [],
        bestSubmissionVigilanteAddressList: [],
    };
}
exports.BTCCheckpointInfo = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.epochNumber !== 0) {
            writer.uint32(8).uint64(message.epochNumber);
        }
        if (message.bestSubmissionBtcBlockHeight !== 0) {
            writer.uint32(16).uint32(message.bestSubmissionBtcBlockHeight);
        }
        if (message.bestSubmissionBtcBlockHash.length !== 0) {
            writer.uint32(26).bytes(message.bestSubmissionBtcBlockHash);
        }
        for (const v of message.bestSubmissionTransactions) {
            exports.TransactionInfo.encode(v, writer.uint32(34).fork()).join();
        }
        for (const v of message.bestSubmissionVigilanteAddressList) {
            exports.CheckpointAddresses.encode(v, writer.uint32(42).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBTCCheckpointInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.epochNumber = longToNumber(reader.uint64());
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.bestSubmissionBtcBlockHeight = reader.uint32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.bestSubmissionBtcBlockHash = reader.bytes();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.bestSubmissionTransactions.push(exports.TransactionInfo.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.bestSubmissionVigilanteAddressList.push(exports.CheckpointAddresses.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            epochNumber: isSet(object.epochNumber) ? globalThis.Number(object.epochNumber) : 0,
            bestSubmissionBtcBlockHeight: isSet(object.bestSubmissionBtcBlockHeight)
                ? globalThis.Number(object.bestSubmissionBtcBlockHeight)
                : 0,
            bestSubmissionBtcBlockHash: isSet(object.bestSubmissionBtcBlockHash)
                ? bytesFromBase64(object.bestSubmissionBtcBlockHash)
                : new Uint8Array(0),
            bestSubmissionTransactions: globalThis.Array.isArray(object?.bestSubmissionTransactions)
                ? object.bestSubmissionTransactions.map((e) => exports.TransactionInfo.fromJSON(e))
                : [],
            bestSubmissionVigilanteAddressList: globalThis.Array.isArray(object?.bestSubmissionVigilanteAddressList)
                ? object.bestSubmissionVigilanteAddressList.map((e) => exports.CheckpointAddresses.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.epochNumber !== 0) {
            obj.epochNumber = Math.round(message.epochNumber);
        }
        if (message.bestSubmissionBtcBlockHeight !== 0) {
            obj.bestSubmissionBtcBlockHeight = Math.round(message.bestSubmissionBtcBlockHeight);
        }
        if (message.bestSubmissionBtcBlockHash.length !== 0) {
            obj.bestSubmissionBtcBlockHash = base64FromBytes(message.bestSubmissionBtcBlockHash);
        }
        if (message.bestSubmissionTransactions?.length) {
            obj.bestSubmissionTransactions = message.bestSubmissionTransactions.map((e) => exports.TransactionInfo.toJSON(e));
        }
        if (message.bestSubmissionVigilanteAddressList?.length) {
            obj.bestSubmissionVigilanteAddressList = message.bestSubmissionVigilanteAddressList.map((e) => exports.CheckpointAddresses.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.BTCCheckpointInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBTCCheckpointInfo();
        message.epochNumber = object.epochNumber ?? 0;
        message.bestSubmissionBtcBlockHeight = object.bestSubmissionBtcBlockHeight ?? 0;
        message.bestSubmissionBtcBlockHash = object.bestSubmissionBtcBlockHash ?? new Uint8Array(0);
        message.bestSubmissionTransactions =
            object.bestSubmissionTransactions?.map((e) => exports.TransactionInfo.fromPartial(e)) || [];
        message.bestSubmissionVigilanteAddressList =
            object.bestSubmissionVigilanteAddressList?.map((e) => exports.CheckpointAddresses.fromPartial(e)) || [];
        return message;
    },
};
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(globalThis.String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
function longToNumber(int64) {
    const num = globalThis.Number(int64.toString());
    if (num > globalThis.Number.MAX_SAFE_INTEGER) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (num < globalThis.Number.MIN_SAFE_INTEGER) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return num;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=btccheckpoint.js.map